<fw-dialog title="Promote to Shared Data Views" width="small">
  <fw-dialog-content [padded]="true">
    <fw-section-heading [description]="dialogDescription"> </fw-section-heading>
    <form [formGroup]="form">
      <fw-layout-panel>
        <fw-form-heading title="Name"></fw-form-heading>
        <fw-text-input test-id="name" placeholder="Name" formControlName="label"></fw-text-input>
      </fw-layout-panel>
      <fw-layout-panel>
        <fw-form-heading title="Description"></fw-form-heading>
        <fw-text-input test-id="description" placeholder="Description" formControlName="description"></fw-text-input>
      </fw-layout-panel>
    </form>
  </fw-dialog-content>
  <fw-dialog-actions>
    <fw-button test-id="project-dialog-close" variant="outline" (click)="closeDialog()">Cancel</fw-button>
    <fw-button test-id="promote-data-view" [disabled]="form.disabled || !form.valid" (click)="onPromote()">
      Promote
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>
